module.exports = __webpack_public_path__ + "static/media/cigars.ec63fc13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/cigars.jpg
// module id = 84
// module chunks = 0